import React, { useState } from "react";
import "./Membership.sass";
import demigods from "./../../../assets/images/halls-demigods.png";
import kek from "./../../../assets/images/halls-kek-2.png";
import froggods from "./../../../assets/images/halls-froggods.png";

export default function Membership() {
  const [video, setVideo] = useState(true);
  return (
    <div className="membership">
      <div className="membership-bg">
        <div className="membership-container">
          <div className="membership-kek">
            <h2 className={`membership-kek-title ${!video && "member-hide"}`}>
              FrenDAO Membership
            </h2>
            <div className="membership-kek-image">
              {video ? (
                <img src={kek} alt="video" onClick={() => setVideo(false)} />
              ) : (
                <iframe
                  src="https://www.youtube.com/embed/TF-yrLkRU4U?autoplay=1&mute=1&enablejsapi=1&rel=0&modestbranding=1"
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  autoPlay={!video}
                ></iframe>
              )}
            </div>
          </div>
          <div className="membership-frogods">
            <div className="membership-froggods-image">
              <img src={froggods} alt="froggods" />
            </div>
            <h2 className="membership-froggods-title">
              FrogGods 17 FrenDAO Leaders
            </h2>
          </div>
          <div className="membership-demigods">
            <div className="membership-demigods-image">
              <img src={demigods} alt="demigods" />
            </div>
            <h2 className="membership-demigods-title">
              DemiGods 100 FrenDAO members
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
}
